// extracted by mini-css-extract-plugin
export default {"categories_cont":"popular_categories_cont__ZuWIB","cate_box":"popular_cate_box__kn+M2","cate":"popular_cate__t3W7K","active":"popular_active__pGtf+"};